import React from 'react';
import './SimpleSlider.css';

interface SimpleSliderProps {
  label: string;
  value: [number, number];
  min: number;
  max: number;
  step?: number;
  onChange: (value: [number, number]) => void;
}

const SimpleSlider: React.FC<SimpleSliderProps> = ({ 
  label, 
  value, 
  min, 
  max, 
  step = 1,
  onChange 
}) => {
  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMin = parseFloat(e.target.value);
    if (newMin <= value[1]) {
      onChange([newMin, value[1]]);
    }
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMax = parseFloat(e.target.value);
    if (newMax >= value[0]) {
      onChange([value[0], newMax]);
    }
  };

  return (
    <div className="simple-slider">
      <label className="simple-slider-label">{label}</label>
      <div className="simple-slider-inputs">
        <input
          type="number"
          value={value[0]}
          min={min}
          max={max}
          step={step}
          onChange={handleMinChange}
          className="simple-input"
        />
        <span>-</span>
        <input
          type="number"
          value={value[1]}
          min={min}
          max={max}
          step={step}
          onChange={handleMaxChange}
          className="simple-input"
        />
      </div>
      <div className="simple-slider-track">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[0]}
          onChange={handleMinChange}
          className="simple-range"
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value[1]}
          onChange={handleMaxChange}
          className="simple-range"
        />
      </div>
    </div>
  );
};

export default SimpleSlider;
